export enum Gender {
  female = 'female',
  male = 'male',
  maleToFemale = 'male_to_female',
  femaleToMale = 'female_to_male',
}
